/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  RenQunBaoChaXunTiaoJian,
  RenQunBaoChuangJianCongURLDaoRu,
  RenQunBaoID,
  ResponseApiIPageRenQunBaoLieBiaoXiang,
  ResponseApiRenQunBaoXiangQing,
  ResponseApiVoid,
} from "./data-contracts";
import { HttpClient, RequestParams, ContentType } from '@gatherstar/utils';

export class RenQunBaoGuanLi<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags RenQunBaoGuanLi
   * @name CreateUsingPost
   * @summary 新增人群包（从URL导入）
   * @request POST:/dsp-admin/api/audience-package/create
   * @secure
   */
  createUsingPost = (
    createDTO: RenQunBaoChuangJianCongURLDaoRu,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiRenQunBaoXiangQing, void>({
      path: `/dsp-admin/api/audience-package/create`,
      method: "POST",
      body: createDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags RenQunBaoGuanLi
   * @name DeleteUsingPost
   * @summary 删除人群包
   * @request POST:/dsp-admin/api/audience-package/delete
   * @secure
   */
  deleteUsingPost = (dto: RenQunBaoID, params: RequestParams = {}) =>
    this.request<ResponseApiVoid, void>({
      path: `/dsp-admin/api/audience-package/delete`,
      method: "POST",
      body: dto,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags RenQunBaoGuanLi
   * @name GetByIdUsingPost
   * @summary 查询人群包详情
   * @request POST:/dsp-admin/api/audience-package/detail
   * @secure
   */
  getByIdUsingPost = (dto: RenQunBaoID, params: RequestParams = {}) =>
    this.request<ResponseApiRenQunBaoXiangQing, void>({
      path: `/dsp-admin/api/audience-package/detail`,
      method: "POST",
      body: dto,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags RenQunBaoGuanLi
   * @name ListUsingPost
   * @summary 分页查询人群包列表
   * @request POST:/dsp-admin/api/audience-package/list
   * @secure
   */
  listUsingPost = (
    queryDTO: RenQunBaoChaXunTiaoJian,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiIPageRenQunBaoLieBiaoXiang, void>({
      path: `/dsp-admin/api/audience-package/list`,
      method: "POST",
      body: queryDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}


// 导出默认实例，可直接使用
export const api = new RenQunBaoGuanLi();
